class SalesRepSelector extends HTMLElement {
  constructor() {
    super();
    this.updateTimeout = null;
    this.addEventListener('change', this.onSelectionChange.bind(this));
    this.init();
  }

  init() {
    try {
      const salesRepsData = this.dataset.salesReps;
      let salesReps;
      
      if (salesRepsData) {
        salesReps = JSON.parse(salesRepsData);
        
        if (!Array.isArray(salesReps) || salesReps.length === 0) {
          throw new Error('Ambassador data is not a valid array or is empty');
        }
        
        if (!salesReps.every(rep => typeof rep === 'string' && rep.trim().length > 0)) {
          throw new Error('Ambassador data contains invalid items');
        }
        
      } else {
        throw new Error('No ambassador data found');
      }
      
      this.populateDropdown(salesReps);
      this.loadSavedSelection();
      this.show();
      
    } catch (error) {
      console.error('Error initializing ambassador selector:', error);
      this.hide();
    }
  }

  populateDropdown(salesReps) {
    const select = this.querySelector('select');
    if (!select) {
      throw new Error('Select element not found');
    }

    select.innerHTML = '';
    
    const defaultOption = document.createElement('option');
    defaultOption.value = '';
    defaultOption.textContent = 'Select an Ambassador';
    select.appendChild(defaultOption);

    salesReps.forEach(repName => {
      const option = document.createElement('option');
      option.value = repName;
      option.textContent = repName;
      select.appendChild(option);
    });
  }

  loadSavedSelection() {
    const select = this.querySelector('select');
    if (!select) return;
    
    // Load from sessionStorage instead
    const savedRep = sessionStorage.getItem('selectedSalesRep');
    
    if (savedRep) {
      select.value = savedRep;

    } else {
      select.value = '';

    }
  }

  show() {
    this.style.display = 'block';
    this.setAttribute('aria-hidden', 'false');
  }

  hide() {
    this.style.display = 'none';
    this.setAttribute('aria-hidden', 'true');
  }

  onSelectionChange(event) {
    // Only handle changes from our select element
    if (event.target.tagName !== 'SELECT' || !event.target.closest('sales-rep-selector')) {
      return;
    }

    // Stop the event from bubbling to prevent interference with other cart JS
    event.stopPropagation();
    event.stopImmediatePropagation();
    
    const selectedValue = event.target.value;
    
    // Clear any pending updates
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
    }
    
    // Save to sessionStorage immediately for better UX
    try {
      if (selectedValue) {
        sessionStorage.setItem('selectedSalesRep', selectedValue);
      } else {
        sessionStorage.removeItem('selectedSalesRep');
      }
    } catch (error) {
      console.warn('Could not save to sessionStorage:', error);
    }

    // Debounce any additional processing (if needed in the future)
    this.updateTimeout = setTimeout(() => {
    }, 300);
  }


}

customElements.define('sales-rep-selector', SalesRepSelector);